module.exports = __webpack_public_path__ + "img/chr_ts_9.b857fbba.png";